<template>
	<div class="p-fluid formgrid grid card">
		<template v-if="loader==true">
			<div class="col-12 mb-2 lg:col-12">
				<ProgressBar mode="indeterminate" style="height: .5em" class="my-1"/>
			</div>
		</template>
		<div class="col-12 lg:col-12">
			<h4>Administrar Usuarios</h4>
		</div>
		<div class="col-3 lg:col-2 my-1">
			<span class="p-float-label">
				<InputText v-model="frmfiltros.document_user" id="document_user" type="number" />
				<label for="document_user">Documento</label>
			</span>
		</div>
		<div class="col-3 lg:col-2 my-1">
			<span class="p-float-label">
				<InputText v-model="frmfiltros.name_user" id="name_user" />
				<label for="name_user">Nombre</label>
			</span>
		</div>

		<div class="col-3 lg:col-2 my-1">
			<span class="p-float-label">
				<InputText v-model="frmfiltros.email_user" id="email_user" />
				<label for="email_user">Correo</label>
			</span>
		</div>

		<div class="col-2 mt-1">
			
		</div>

		<div class="col-2 lg:col-2 my-1">
			<Button label="Buscar" icon="pi pi-search" class="p-button-rounded p-button-prymary" :loading="loader" @click="cargar_usuarios(1)" />
		</div>
		<div class="col-2 lg:col-2 my-1">
			<Button label="Limpiar" icon="pi pi-filter-slash" class="p-button-rounded p-button-prymary" :loading="loader" @click="limpiar" />
		</div>
		<div class="col-12 lg:col-12 mt-2">
			<DataTable ref="pagination" :value="usuarios" v-model:selection="selectedClients" dataKey="id" :paginator="false" :rows="3" @paginate="onChangePage"
						:paginatorTemplate="'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'"
						:currentPageReportTemplate="'Showing '+pagination.from+' to '+pagination.to+' of '+pagination.total+' customers'" responsiveLayout="scroll">
				<Column field="document" header="Documento" :sortable="false">
					<template #body="slotProps">
						<span class="p-column-title">document</span>
						{{slotProps.data.document}}
					</template>
				</Column>
				<Column field="name" header="Nombre" :sortable="false">
					<template #body="slotProps">
						<span class="p-column-title">name</span>
						{{slotProps.data.name}}
					</template>
				</Column>
				<Column field="email" header="Correo" :sortable="false">
					<template #body="slotProps">
						<span class="p-column-title">email</span>
						{{slotProps.data.email}}
					</template>
				</Column>
				<Column field="customer_job" header="Cargo" :sortable="false">
					<template #body="slotProps">
						<span class="p-column-title">customer_job</span>
						{{slotProps.data.customer_job}}
					</template>
				</Column>
				<Column field="acciones" header="Acciones">
					<template #body="slotProps">
						<Button icon="pi pi-key" title="Administrar Accesos" class="p-button-rounded p-button-success p-button-outlined" :loading="loader" @click="openmodalUsuarios(slotProps.data)" />
					</template>
				</Column> 
			</DataTable>
			<div>
				<Paginator :v-model:first="pagination.from" :rows="pagination.per_page" :rowsPerPageOptions="[15]" :totalRecords="pagination.total" @page="onChangePage($event)"></Paginator>
			</div>
		</div>
		<Dialog v-model:visible="modalusuario" :style="{width: '950px'}" :header="frmUsuario.name ?? 'Crear Cliente'" :modal="true" class="p-fluid">
			<div class="field formgrid grid my-3">
				<!-- <p>{{img_profile}}</p> -->
				<!-- <p>{{frmUsuario}}</p> -->
				<div class="col-4">
					<!-- <template v-if="frmUsuario.id!=0"> -->
						<div class="text-center align-items-center">
							<img class="mt-3 cursor-pointer rounded-circle img-thumbnail" :src="img_profile" alt="profile" @click="openmodalmedia" width="130">
							<h5 class="mb-1">{{frmUsuario.name}}</h5>
							<div class="mb-2 mt-2">
								<i class="pi pi-envelope mr-1"></i>
								<span>{{frmUsuario.email}} </span>
								<template v-if="frmUsuario.email_verified_at==null">
									<Badge value="SIN VERIFICAR" severity="danger" class="ml-1"></Badge>
								</template>
								<template v-else>
									<Badge value="VERIFICADO" severity="success" class="ml-1"></Badge>
								</template>
								<br>
							</div>
							<div class="mb-2 mt-2">
								<i class="pi pi-id-card mr-1"></i>
								<span>{{frmUsuario.document}}</span><br>
							</div>
							<div class="mb-2 mt-2">
								<i class="pi pi-phone mr-1"></i>
								<span>{{frmUsuario.cellphone}}</span><br>
							</div>
							<div class="mb-2 mt-2">
								<i class="pi pi-briefcase mr-1"></i>
								<span>{{frmUsuario.customer_job}}</span><br>
							</div>
						</div>
					<!-- </template> -->

				</div>
				<div class="col-8 grid card">
					<div class="field col-12 text-center">
						<h5>Roles</h5>
						<TabView v-model="activeIndex">
							<TabPanel header="Generador" class="pt-2">
								
								<div class="font-medium text-3xl text-900 mb-3 pt-1 pl-3">Generadores</div>
								<div class="text-500 mb-5 pl-3">Aquí encuentra su información de las empresas de transporte<br> con estado y opciones.</div>
								<div class="col-12">
									<Accordion>
										<template v-for="(grup_empr,index) in grupos_empresariales_customers" :key="index">
										<AccordionTab>
											<template v-slot:header>
												<div class="flex align-items-center">
													<i class="pi pi-bookmark fs-xlarge mr-3 pink-color"></i>
													<div class="flex flex-column">
														<h5 class="mb-0">{{grup_empr.name}}</h5>
														<p>NIT: {{grup_empr.document}}</p>
													</div>
												</div>
											</template>
											
											<ul class="list-none p-0 m-0">
												<template v-for="(empresa,index_empresas) in grup_empr.empresas" :key="index_empresas">
												<li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
													<div class="text-500 w-6 md:w-2 font-medium">Nombre</div>
														<div class="text-900 w-full md:w-7 md:flex-order-0 flex-order-1">{{empresa.razon_social}}</div>
														
															<template v-if="empresa.status == 0">
																<div class="w-6 md:w-3 flex justify-content-end"><Badge value="Pendiente" severity="warning" class="mr-2 cursor-pointer" @click="openmodalstatusUser(empresa)"></Badge></div>
															</template>
															<template v-if="empresa.status == 1">
																<div class="w-6 md:w-3 flex justify-content-end"><Badge value="Activo" severity="primary" class="mr-2 cursor-pointer" @click="openmodalstatusUser(empresa)"></Badge></div>
															</template>
															<template v-if="empresa.status == 2">
																<div class="w-6 md:w-3 flex justify-content-end"><Badge value="Bloqueado" severity="danger" class="mr-2 cursor-pointer" @click="openmodalstatusUser(empresa)"></Badge></div>
															</template>
															
														
													<div class="w-6 md:w-3 flex justify-content-end">
													</div>
												</li>
												</template>
											</ul>
										
										</AccordionTab>
										</template>
									</Accordion>
								</div>
							</TabPanel>
							<TabPanel header="Empresa Transporte" class="pt-2">
								<div class="font-medium text-3xl text-900 mb-3 pt-1 pl-3">Empresas de Transporte</div>
								<div class="text-500 mb-5 pl-3">Aquí encuentra su información de las empresas de transporte<br> con estado y opciones.</div>
								<ul>
									<li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
										<div class="text-500 w-6 md:w-2 font-medium">Nombre</div>
											<div class="text-900 w-full md:w-7 md:flex-order-0 flex-order-1">{{empresa_transporte.name}}</div>
											
												<template v-if="empresa_transporte.status == 0">
													<div class="w-6 md:w-3 flex justify-content-end"><Badge value="Pendiente" severity="warning" class="mr-2 cursor-pointer" @click="openmodalstatusUser(empresa_transporte)"></Badge></div>
												</template>
												<template v-if="empresa_transporte.status == 1">
													<div class="w-6 md:w-3 flex justify-content-end"><Badge value="Activo" severity="primary" class="mr-2 cursor-pointer" @click="openmodalstatusUser(empresa_transporte)"></Badge></div>
												</template>
												<template v-if="empresa_transporte.status == 2">
													<div class="w-6 md:w-3 flex justify-content-end"><Badge value="Bloqueado" severity="danger" class="mr-2 cursor-pointer" @click="openmodalstatusUser(empresa_transporte)"></Badge></div>
												</template>
												
											
										<div class="w-6 md:w-3 flex justify-content-end">
										</div>
									</li>
								</ul>
								
							</TabPanel>
						</TabView>
					</div>
				
					<!-- <div class="card"> -->
						
						
					<!-- </div> -->
				</div>
				
			</div>
			
			<template #footer>
				<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalusuario = false"/>
			</template>
		</Dialog>
		<Dialog v-model:visible="modalstatusUser" :style="{width: '300px'}" :header="'Selecciona el Estado'" :modal="true" class="p-fluid">
			<div class="field formgrid grid p-fluid">
				<div class="col-12">
					<!-- <h3>{{radioStatus}}</h3> -->
					<div class="field-radiobutton">
						<RadioButton inputId="radioStatus0" name="radioStatus" :value="0" v-model="radioStatus" />
						<!-- <label for="radioStatus0">Pendiente</label> -->
						<Badge value="Pendiente" severity="warning" class="ml-2"></Badge>
					</div>
					<div class="field-radiobutton">
						<RadioButton inputId="radioStatus1" name="radioStatus" :value="1" v-model="radioStatus" />
						<Badge value="Activo" severity="primary" class="ml-2"></Badge>
					</div>
					<div class="field-radiobutton">
						<RadioButton inputId="radioStatus2" name="radioStatus" :value="2" v-model="radioStatus" />
						<Badge value="Bloqueado" severity="danger" class="ml-2"></Badge>
					</div>
					
				</div>
				
			</div>
			
			<template #footer>
				<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalstatusUser = false"/>
				<Button label="Guardar" icon="pi pi-save" class="p-button-text" @click="guardar_status"/>
				
			</template>
		</Dialog>
	</div>
</template>

<script>
import { APIENDPOINTIMG } from '../../app.config'
export default {
	data() {
		return {
			loader: false,
			switchValue: false,
			submitted: false,
			modalimgCustomer: false,
			modalusuario: false,
			modalstatusUser: false,
			usuarios: [],
			selectedClients: null,
            pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			frmUsuario: {},
			activeIndex: 0,
			img_profile: '',
			grupos_empresariales_customers: [],
			empresa_transporte: {},
			frmfiltros: {
                document_user: '',
				name_user: '',
				email_user: ''
            },
			radioStatus: null
		}
	},
	mounted(){
		this.cargar_usuarios(1);
	},
	methods:{
		onChangePage(page) {
			this.cargar_usuarios(page.page+1);
		},
		limpiar(){
			this.frmfiltros.document_user = '';
			this.frmfiltros.name_user = '';
			this.frmfiltros.email_user = '';
			this.cargar_usuarios(1);
		},
		cargar_usuarios(page){
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
				document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
				})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.usuarios = [];
				window.api.call('post', '/cargar_usuarios?&page='+page, {email: email,id_rol: id_rol,frmfiltros: this.frmfiltros}).then( function(response) {
					if(response.status == 200){
						_that.usuarios = response.data.data.data;
						_that.pagination = response.data.data;
						_that.loader = false;
					}
				}).catch(function (err) {
					console.log(err);
					_that.loader = false;
					_that.loader_opt = false;
				});
		},
		openmodalUsuarios(data){
			this.loader = true;
			var _that = this;
			this.grupos_empresariales_customers = [];
			this.empresa_transporte = {};
			window.api.call('post', '/cargar_empresas_usuario', {id: data.id}).then( function(response) {
				if(response.status == 200){
					_that.grupos_empresariales_customers = response.data.data;
					if (response.data.empresa_transporte.length>0) {
						_that.empresa_transporte = response.data.empresa_transporte[0];
					}
					
					_that.loader = false;
					_that.modalusuario = true;
					_that.frmUsuario = data;
					if(data.avatar==null){
						_that.img_profile = APIENDPOINTIMG+'img_profiles/profile.jpg';
					}else{
						_that.img_profile = APIENDPOINTIMG+'img_profiles/'+data.avatar;
					}
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
			});
		},
		openmodalstatusUser(data){
			this.modalstatusUser = true;
			this.radioStatus = data.status;
		},
		guardar_status(){
			if (this.activeIndex == 0) {
				this.$toast.add({ severity: 'success', summary: 'Estado Genarador:', detail: 'Cambiado con Exito!', life: 6000 });
			}else{
				this.$toast.add({ severity: 'success', summary: 'Estado Empresa de Transporte:', detail: 'Cambiado con Exito!', life: 6000 });
			}
		}
	}
}
</script>

<style scoped>

</style>
